import script from "./authorizeExpired.vue?vue&type=script&setup=true&lang=js"
export * from "./authorizeExpired.vue?vue&type=script&setup=true&lang=js"

import "./authorizeExpired.vue?vue&type=style&index=0&id=c365a422&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c365a422"]])

export default __exports__